
document.addEventListener("DOMContentLoaded", function () {
	class NavigationHandler
    {
		blockEl;
		navEl;
		openNavButton;
		closeNavButton;

        constructor(blockEl) {
			this.blockEl = blockEl;

			this.navEl = this.blockEl.querySelector("nav");
			this.openNavButton = this.blockEl.querySelector(".open-nav-button");
			this.closeNavButton = this.blockEl.querySelector(".close-nav-button");
			this.menuItemsWithChildren = this.blockEl.querySelectorAll(".menu-item-has-children");

            this.setEventListeners();
        }

        toggleMenu() {
            this.navEl.classList.toggle("active");
			document.documentElement.classList.toggle('has-modal-open');
		}

		updateAlignment() {
			if (this.navEl.scrollHeight > window.innerHeight) {
				this.navEl.style.alignItems = 'flex-start';
			} else {
				this.navEl.style.alignItems = 'center';
			}
		}

        setEventListeners() {
            this.openNavButton.addEventListener("click", () => this.toggleMenu());
            this.closeNavButton.addEventListener("click", () => this.toggleMenu());

			this.menuItemsWithChildren.forEach(item => {
				var submenu = item.querySelector('.sub-menu');
				var toggleButton = item.querySelector('.submenu-toggle');

				toggleButton.addEventListener('click', function() {
					var isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';

					toggleButton.setAttribute('aria-expanded', !isExpanded);
					submenu.setAttribute('aria-hidden', isExpanded);
				});
				toggleButton.addEventListener('focusout', function(event) {
					if (!submenu.contains(event.relatedTarget) && !toggleButton.contains(event.relatedTarget)) {
						toggleButton.setAttribute('aria-expanded', 'false');
						submenu.setAttribute('aria-hidden', 'true');
					}
				});

				// Close submenu when focus moves outside of it
				submenu.addEventListener('focusout', function(event) {
					if (!submenu.contains(event.relatedTarget) && !toggleButton.contains(event.relatedTarget)) {
						toggleButton.setAttribute('aria-expanded', 'false');
						submenu.setAttribute('aria-hidden', 'true');
					}
				});
			});

			window.addEventListener('resize', () => this.updateAlignment());
			window.addEventListener('load', () => this.updateAlignment());
        };
    }

	var blocks = document.querySelectorAll(
		".wp-block-moods-blocks-navigation",
	);

	blocks.forEach((item) => {
		new NavigationHandler(item);
	});
});
